var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-add-salesChannel"},[_c('error',{attrs:{"err":_vm.error},on:{"update:err":function($event){_vm.error=$event}}}),_c('form-generator',{attrs:{"elements":_vm.elements,"data":_vm.channel,"handleUpdate":({ key }, v) => (_vm.channel[key] = v)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }